export default {
  setWorkshops (state, payload) {
    state.list = payload
  }
}